import BgImage from './components/bg-image/bg-image.vue'

import veeValidate from 'vee-validate'
import {
    Validator
} from 'vee-validate';

import vueResource from 'vue-resource'
import VueRecaptcha from 'vue-recaptcha'

Vue.use(veeValidate);
Vue.use(vueResource);
Vue.use(VueRecaptcha);

Vue.http.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;

const url = "/en/contact/send";

// CUSTOM ERROR MESSAGES
const dict = {
    custom: {
        name: {
            required: 'required',
        },
        email: {
            required: 'required',
            email: 'must be a valid email'
        },
        subject: {
            required: 'required',
        },
        message: {
            required: 'required',
            max: 'max char 300'
        },
    }
};

Validator.localize('en', dict);

Vue.component('contactPage', {
    components: {
        VueRecaptcha,
        BgImage
    },
    props: ['pagedata', '_perpage', '_limit', '_allitems'],
    data() {
        return {
            contactform: {
                _token: window.Laravel.csrfToken,
                name: '',
                email: '',
                subject: '',
                message: '',
                'g-recaptcha-response': '',
            },
            responseMsg: '',
            responseClass: '',
            applyingForm: false,

            items: this.pagedata ? this.pagedata.items.data : [],
            categories: this.pagedata.categories ? this.pagedata.categories : [],
            allitems: this._allitems,
            limit: this._limit ? this._limit : 1,
            perpage: this._perpage,
            active_item: []
        }
    },
    methods: {
        triggerInfobox() {
            console.log('open infobox');
        },
        uploadFile() {
            var filename = this.$refs.file.value;
            this.cv = filename;
        },
        // Update on soft keyboards
        onType(e) {
            // this.contactform[e.target.name] = e.target.value;
        },
        clearForm() {
            this.contactform = {
                _token: window.Laravel.csrfToken,
                name: '',
                email: '',
                subject: '',
                message: '',
                'g-recaptcha-response': '',
            };
            this.applyingForm = false;
            this.$validator.reset();
        },
        executeCaptcha(event) {
            this.applyingForm = true;
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$refs.recaptcha.execute();
                } else {
                    // console.log("Error: ", '#' + this.$validator.errors.items[0].field);
                    document.querySelector('#' + this.$validator.errors.items[0].field).focus()
                    this.applyingForm = false;
                }
            });
        },

        onCaptchaVerified(token) {
            this.contactform['g-recaptcha-response'] = token;
            this.submitForm();
        },

        submitForm(e) {
            this.$validator.validateAll().then((result) => {

                if (result) {
                    var data = new FormData();
                    for (var prop in this.contactform) {
                        if (this.contactform.hasOwnProperty(prop)) {
                            data.append(prop, this.contactform[prop]);
                        }
                    }
                    this.$http.post(url, data, {
                        headers: {
                            'Content-Type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
                        }
                    }).then(
                        function (dataSucc) {
                            this.responseMsg = dataSucc.body.message;
                            this.responseClass = "form-success";
                            this.applyingForm = false;
                            this.clearForm();
                            this.resetCaptcha();

                            setTimeout(function () {
                                this.responseMsg = '';
                            }, 2000);
                        },
                        function (dataError) {
                            this.responseMsg = dataError.body.message;
                            this.responseClass = "form-danger";
                            this.applyingForm = false;
                            this.clearForm();
                            this.resetCaptcha();

                            setTimeout(function () {
                                this.responseMsg = '';
                            }, 2000);
                        }
                    );
                } else {
                    this.responseMsg = "Check the fields for errors.";
                    this.responseClass = "text-danger";
                    console.log("Error: ", result);
                }
            });
        },

        resetCaptcha() {
            this.$refs.recaptcha.reset()
        }
    },
    filters: {
        fakepath(value) {
            return value.replace("C:\\fakepath\\", '');
        }
    },
    mounted() {}
})


// WEBPACK FOOTER //
// ./src/js/contact.js